import { ReasoningUIPart } from 'ai';

import { getReasoningTitle } from '../../../utils';
import CollapsibleContent from '../../CollapsibleContent';

import Markdown from '@/routes/smart-search/components/Markdown';

interface ReasoningProps {
  part: ReasoningUIPart;
}

const Reasoning: React.FC<ReasoningProps> = ({ part }) => (
  <CollapsibleContent
    shimmer={part.state === 'streaming'}
    spread={1}
    title={getReasoningTitle(part.text)}
  >
    <Markdown text={part.text} className="text-sm text-gray-600/70" />
  </CollapsibleContent>
);

export default Reasoning;
